import styles from "./Subpage.module.css";
import { useDeviceClassification, useSubPageContent } from "utils";
import { SubPageContent } from "./content";
import {
  Page,
  ContentContainer,
  Loading,
  SideBar
} from "components/atoms";
import {
  Sharing,
  RelatedContent,
  ScrollToTopButton,
  PublicationTags,
  AuthorByline

} from "components/molecules";
import { Header } from "./header";
import { useEffect, useState } from "react";
import {
  TextEditor,
  ButtonGroup,
  ContentBlocks,
  Tags,
} from "components/molecules";
import _ from "lodash";
import { ImageGalleryMain } from "components/molecules/ImageGalleryMain/ImageGalleryMain";
import React from "react";
import classNames from "classnames";
import { ContactUsForm, ContactUsSection } from "components/organisms";

const SubPage = ({ id }) => {
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setPageLoading(false), 500);
  }, []);

  const {
    loading,
    HeroSectionTitle,
    HeroSectionSuperscript,
    HeroSectionBlockOverlayColor,
    HeroSectionBlockOverlayColumn,
    TextEditor1,
    TextEditor2,
    ButtonSelection1,
    ButtonSelection2,
    ButtonAlignment1,
    ButtonAlignment2,
    HeroSectionVideo,
    HeroSectionVideoLoop,
    HeroSectionVideoAutoplay,
    ContentBlocks: CBS,
    ImagePool,
    ShowImageCaptions,
    Tags: TagArray,
    TagFilterByUrl,
    RelatedContent: Related,
    RelatedContentHeading,
    heroPanels,
    ShowSocialSharing,
    ShowRelatedContent,
    ShowAbstracts,
    LargeContactCards,
    PublicationDate,
    ReadTime,
    ContentType,
    ShowPublicationDateReadTimeContentType,
    HeroSectionImageMobile,
    HeroSectionVideoMobile,

    Authors,

    ContactLinkPool,
    ContactUsTitle,
    ContactUsDescription,

    QuickFactsLocationTitle,
    QuickFactsLocationContent,
    QuickFactsClientTitle,
    QuickFactsClientContent,
    QuickFactsProjectPartnersTitle,
    QuickFactsProjectPartnersContent,
    QuickFactsAureconRoleTitle,
    QuickFactsAureconRoleContent,
    QuickFactsAureconExpertiseTitle,
    QuickFactsAureconExpertiseContent,
    QuickFactsStatusTitle,
    QuickFactsStatusContent,
    QuickFactsFeaturesTitle,
    QuickFactsFeaturesContent,

    ShowDownloadIcon,
    ShowQuickFactsSidebar
  } = useSubPageContent();

  
  const sideBarProps = {
    QuickFactsLocationTitle,
    QuickFactsLocationContent,
    QuickFactsClientTitle,
    QuickFactsClientContent,
    QuickFactsProjectPartnersTitle,
    QuickFactsProjectPartnersContent,
    QuickFactsAureconRoleTitle,
    QuickFactsAureconRoleContent,
    QuickFactsAureconExpertiseTitle,
    QuickFactsAureconExpertiseContent,
    QuickFactsStatusTitle,
    QuickFactsStatusContent,
    QuickFactsFeaturesTitle,
    QuickFactsFeaturesContent,
    ShowQuickFactsSidebar
  };

  const contentProps = {
    TextEditor1,
    TextEditor2,
    ButtonSelection1,
    ButtonSelection2,
    ButtonAlignment1,
    ShowImageCaptions,
    ImagePool,
    TagFilterByUrl,
    CBS,
    TagArray,
    Related,
    RelatedContentHeading
  };

  const articleMetaProps = {
    PublicationDate,
    ReadTime,
    ContentType,
    ShowPublicationDateReadTimeContentType,
    Authors,
    ShowQuickFactsSidebar
  };

  const headerProps = {
    HeroSectionTitle,
    HeroSectionSuperscript,
    HeroSectionBlockOverlayColor,
    HeroSectionBlockOverlayColumn,
    HeroSectionVideo,
    HeroSectionVideoLoop,
    HeroSectionVideoAutoplay,
    TagFilterByUrl,
    heroPanels,
    HeroSectionImageMobile,
    HeroSectionVideoMobile,
    ShowQuickFactsSidebar
  };

  const ContactUsSectionProps = {
    ContactLinkPool,
    ContactUsTitle,
    ContactUsDescription
  };

  const DisplaySimplifiedBannerDesktop = !heroPanels?.length;
  const DisplaySimplifiedBannerMobile = !heroPanels?.length && !HeroSectionImageMobile && !HeroSectionVideoMobile;

  /**
  1. Produce joined array of existing ButtonSelection lists
  */
  const ButtonSelectionJoinedArray = () => {
    const selection1 = ButtonSelection1 ? ButtonSelection1 : [];
    const selection2 = ButtonSelection2 ? ButtonSelection2 : [];
    return selection1.concat(selection2);
  };

  // Dynamically set position of figCaption element based on clientScreen
  const { isDesktop, width } = useDeviceClassification();
  const RenderContactForm = LargeContactCards?.length;
  const DisplaySideBar = Boolean(Object.values(sideBarProps).filter((v) => v).length) && ShowQuickFactsSidebar;
  const ContentOrientation = isDesktop && DisplaySideBar ? "space-between" : "center"

  if (loading || pageLoading) return <Loading />;

  return (
    <>
      <Header
        ContentOrientation={ContentOrientation}
        DisplaySimplifiedBannerDesktop={DisplaySimplifiedBannerDesktop}
        DisplaySimplifiedBannerMobile={DisplaySimplifiedBannerMobile}
        {...headerProps} />

      <ContentContainer
        className={classNames({ DisplaySimplifiedBanner: DisplaySimplifiedBannerDesktop || DisplaySimplifiedBannerMobile })}
        background="white"
      >

        <section>
          {/* Article Meta Tags */}
          {Boolean(PublicationDate?.length) &&
            <PublicationTags
              DisplaySimplifiedBannerMobile={DisplaySimplifiedBannerMobile}
              DisplaySimplifiedBannerDesktop={DisplaySimplifiedBannerDesktop}
              isDesktop={isDesktop}
              {...articleMetaProps} />
          }

          <section className={classNames(styles.mainContent, 'mt-20')}>
            {/*Social Sharing Component*/}
            {width > 1350 && <Sharing
              ShowQuickFactsSidebar={ShowQuickFactsSidebar}
              ButtonSelection={ButtonSelectionJoinedArray()}
              ShowSocialSharing={ShowSocialSharing}
              ShowDownloadIcon={ShowDownloadIcon}
              DisplaySimplifiedBannerDesktop={DisplaySimplifiedBannerDesktop}
            />}

            <Page
              flexDirection={isDesktop ? 'unset' : 'column-reverse'}
              contentOrientation={ContentOrientation}
            >

              {/* Fixed Element Scroll To Top Button */}
              <ScrollToTopButton />

              {/*Content*/}
              <SubPageContent
                DisplaySideBar={DisplaySideBar}
                isDesktop={isDesktop}
                DisplaySimplifiedBannerDesktop={DisplaySimplifiedBannerDesktop}
                DisplaySimplifiedBannerMobile={DisplaySimplifiedBannerMobile}
                {...contentProps}
              >
               { Boolean(Authors?.length) && <AuthorByline {...articleMetaProps} />}
              </SubPageContent>


              {/*Display Sidebar and Sidebar on following conditions*/}
              {DisplaySideBar && <SideBar />}

            </Page >

            {/* Image Gallery */}
            {ImagePool?.length > 0 &&
              <Page>
                <div className={classNames(styles.content, isDesktop ? 'col-8' : 'col-12', { 'm-auto': !DisplaySideBar }, 'animateonscroll')}>
                  <ImageGalleryMain ShowCaptions={ShowImageCaptions} noArrows large images={ImagePool} />
                </div>
              </Page>
            }

            {/* Content */}
            {CBS?.length > 0 && <ContentBlocks
              ShowSidebar={ShowQuickFactsSidebar}
              ShowCaptions={ShowImageCaptions}
              id={id}
              blocks={CBS}
              isDesktop={isDesktop}
            />}

            <Page>
              <div className={classNames(styles.content, 'first-child-m-0', isDesktop ? 'col-8' : 'col-12', { 'm-auto': !DisplaySideBar })}>
                {TextEditor2 && <TextEditor isDesktop={isDesktop} data={TextEditor2} />}

                {ButtonSelection2?.length > 0 && (
                  <ButtonGroup className="button-group-2" alignment={ButtonAlignment2} buttons={ButtonSelection2} />
                )}

                {TagArray && TagFilterByUrl && (
                  <Tags tags={TagArray} url={TagFilterByUrl} />
                )}
              </div>
            </Page>


            {Boolean(ContactLinkPool?.length) &&
              <ContactUsSection
                DisplaySideBar={DisplaySideBar}
                {...ContactUsSectionProps}
              />
            }

          </section>
        </section>

        <Page flexDirection="column" className="noPadding">
          {ShowRelatedContent && Related?.length > 0 && (
            <RelatedContent className="animateonscroll" heading={RelatedContentHeading} content={Related} abstracts={ShowAbstracts} />
          )}

          {Boolean(RenderContactForm) && <ContactUsForm data={LargeContactCards[0]} />}

        </Page>

      </ContentContainer >
    </>
  );
};

export default React.memo(SubPage);
